<template lang="html">
  <div class="login auth-view">
    <div class="form-wrap">
      
      <MainLogo/>

      <form @submit="submitForm($event)" class="form">

        <app-text-input
          :label="email.label"
          :type="email.type"
          v-model="email.value"
          required
        />
        <app-text-input
          :label="pass.label"
          :type="pass.type"
          v-model="pass.value"
          required
        />

        <div class="checkboxes">
          <div class="column">
            <app-checkbox
              size="small"
              v-model="agreement"
              :label="$ml.get(`Accept the`)"
              required
            />
            <router-link :to="'/license-terms'" class="license" target="_blank">
              {{ $ml.get(`License Terms`) }}
            </router-link>
          </div>

          <div class="column">
            <router-link :to="'/auth/forgot-password'" class="forgot-password">
              {{$ml.get(`Forgot password?`)}}
            </router-link>
          </div>
        </div>

        <div class="buttons">
          <app-btn :to="'/auth/select-role'" :styling="'outline'">
            {{$ml.get(`Register`)}}
          </app-btn>
          <app-btn
            type="submit"
            :loading="loading"
          >
            {{$ml.get(`Login`)}}
          </app-btn>
        </div>
      </form>
      <!-- <div id="socials-login">
        <span>Login with Google or Facebook</span>
        <LoadingSVG v-if="loading" class="socials-loading" />
        <div v-else id="btns">
          
          <button id="google-login" @click="AuthProvider('google')">
          <img 
            src="@/assets/google-logo.png" 
            alt="Google login"
          />
        </button>
        <button id="facebook-login" @click="AuthProvider('facebook')">
          <img 
            src="@/assets/facebook-logo.png" 
            alt="Facebook login"
          />
        </button>
        </div>
      </div> -->
    </div>

  </div>
</template>

<script>
import { AuthAPI } from '@/api'
import MainLogo from '@/components/auth/MainLogo';
import LoadingSVG from '@/components/ui/LoadingSVG';
import axios from 'axios'

export default {

  components: {
    MainLogo,
    LoadingSVG
  },

  data() {
    return {
        email: {
          label : 'Email',
          type  : 'email',
          value : null
        },
        pass: {
          label : 'Password',
          type  : 'password',
          value : null
        },
        loading: false,
        agreement : false,
        rememberMe : false,
    };
  },

  created() {
    console.log(this.$route)
  },

  methods: {
    submitForm(e) {
      e.preventDefault();

      if(this.agreement !== true) {
        this.$notify({
          group: 'notices',
          title: this.$ml.get(`You must confirm our License Terms!`),
          type : 'error',
        });
        return;
      }

      this.loading = true;
      AuthAPI.login({
        email: this.email.value,
        password: this.pass.value,
      }).then(res => {
        this.$store.commit('user/auth', res.data.access_token);
        return this.$store.dispatch('user/updateData').then(() => {
          this.$router.push('/dashboard/farms/map-view');
        });
      }).catch(err => {
        this.$notify({
          group: 'notices',
          title: this.$ml.get(`Wrong password or email`),
          type : 'error',
        });
      }).finally(() => {
        this.loading = false;
      });

    },
    AuthProvider(provider) {
              this.$auth.authenticate(provider).then(response =>{
                this.SocialLogin(provider,response)
                }).catch(err => {
                    console.log({err:err})
                })
 
            },
 
            SocialLogin(provider,response){
              this.loading = true;
              axios.post(`https://app.smart-dev.co.uk/api/auth/sociallogin/${provider}`, response).then(res => {
                this.$store.commit('user/auth', res.data.access_token);
                return this.$store.dispatch('user/updateData').then(() => {
                  this.$router.push('/dashboard/farms/map-view');
                  if(res.data.message) AuthAPI.sendRegSocialMail();
                });
              }).catch(err => {
                    console.log({err:err})
                }).finally(() => {
                  this.loading = false;
                })
            },
  }
}
</script>

<style lang="scss" scoped>

#socials-login {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 40px;
  .socials-loading {
    height: 50px;
    fill: $mainGreen;
  }
  span {
    margin-bottom: 10px;
  }
  #btns {
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      height: 50px;
      width: 50px;
      border: none;
      background: transparent;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 10px;
      transition: .1s ease;
      &#google-login {
        border: 1px #303030 solid;
      }
      &#facebook-login {
        background: #3b5998;
      }
      &:hover {
        box-shadow: 1px 1px 5px #444444;
        cursor: pointer;
      }
      img {
        height: 70%;
      }
    }
  }
}

.login {


  .form-wrap {

    form {
      width: 400px;

      .checkboxes {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        .column {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          > a { font-size:14px; }

          .license {
            padding-left: 5px;
          }
        }
      }
      .buttons {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .a-btn {
          flex-basis: calc(50% - 6px);
          display: block;
          padding: 6px 0;
          text-align: center;
          font-size: 18px;
        }
      }

    }
  }



  &#content {
    // flex-direction: column;
  }
  .header {
    text-align: center;
    margin: 20px 0;
  }
  .form {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    > * {
      margin: 10px 0 24px;
    }
  }
  @media (max-width:900px) {
    &#content {
      display: block;
      .login-image {
        display: none;
      }
      .login-form {
        padding: 0 12px;
        .form {
          width: 100%;
          margin-bottom: 8px;
          .checkboxes {
            flex-direction: column;
            .column > a {

            }
          }
          .buttons {
            flex-direction: column-reverse;
            > .a-btn {
              text-align: center;
              margin-bottom: 16px;
              padding: 8px 12px;
              line-height: 24px;
              font-size: 24px;
            }
          }
        }
      }
    }
  }
  @media(max-width: 768px) {
    .form-wrap {
      form {
        width: 100%;
        .checkboxes {
          flex-direction: column;
          align-items: flex-start;
          .column:first-child {
            margin-bottom: 16px;
          }
        }
      }
      .logo {
        width: auto;
      }
    }
  }
}


</style>
